import React = require('react')
import { FilterBlockArgs } from './render_filter_block'
import { NavLink } from 'react-router-dom'
import { Map } from 'immutable'
import { resourceIndustryTags, resourceTypeTags, newsTypeTags, vacancyContractTypeTags, vacancyCountryTags, vacancyLocationTags, vacancyDepartmentTags, teamMemberDisciplineTags, testimonialTags, TagValues, vacancyStateProvinceTags } from '../../../../types.mod'
import { PageKind } from '../../overview_page'
import { t } from 'i18next'
import { datalayerHandler } from '../../../../../../cms/blocks/utils/gtm.mod'
import { clickoutside } from '../../../../../../helpers'
import { getDetailPageHeaderImage } from '../../../../../templates/custom_page_header'

let take = (l: any[], amount) => {
  if (amount > l.length) return l
  return l.slice(0, amount)
}

let skip = (l: any[], amount) => {
  if (amount > l.length) return []
  return l.slice(amount)
}

export const VacancyOverviewTagFilterTitle = (tagType: string) => {
  switch (tagType) {
    case vacancyContractTypeTags:
      return "Contract";
    case vacancyCountryTags:
      return "Country";
    case vacancyLocationTags:
      return "Location";
    case vacancyDepartmentTags:
      return "Department";
      case vacancyStateProvinceTags:
        return "State/Province";
    default:
      return '';
  }
}

export const SearchAndTagFilterLayout = (page_kind: PageKind, args: FilterBlockArgs) => {
  let _resourceIndustryTags = args.tags.get(resourceIndustryTags, [])
  let _resourceTypeTags = args.tags.get(resourceTypeTags, [])
  let _newsTypeTags = args.tags.get(newsTypeTags, [])

  let selected_resourceIndustryTags = args.options.tags.get(resourceIndustryTags, [])
  let selected_resourceTypeTags = args.options.tags.get(resourceTypeTags, [])
  let selected_newsTypeTags = args.options.tags.get(newsTypeTags, [])

  let selected_vacancyContractTypeTags = args.options.tags.get(vacancyContractTypeTags, [])
  let selected_vacancyCountryTags = args.options.tags.get(vacancyCountryTags, [])
  let selected_vacancyStateProvinceTags = args.options.tags.get(vacancyStateProvinceTags, [])
  let selected_vacancyLocationTags = args.options.tags.get(vacancyLocationTags, [])
  let selected_vacancyDepartmentTags = args.options.tags.get(vacancyDepartmentTags, [])

  let _vacancyContractTypeTags = args.tags.get(vacancyContractTypeTags, [])
  let _vacancyCountryTags = args.tags.get(vacancyCountryTags, [])
  let _vacancyLocationTags = args.tags.get(vacancyLocationTags, [])
  let _vacancyDepartmentTags = args.tags.get(vacancyDepartmentTags, [])
  let _vacancyStateProvinceTags = args.tags.get(vacancyStateProvinceTags, [])

  let _teamMemberDisciplineTags = args.tags.get(teamMemberDisciplineTags, [])
  let selected_teamMemberDisciplineTags = args.options.tags.get(teamMemberDisciplineTags, [])


  let _testimonialsTags = args.tags.get(testimonialTags, [])
  let selected_testimonialsTags = args.options.tags.get(testimonialTags, [])

  function toggleFilters() {
    const filterOverlay: HTMLElement = document.querySelector('.fo');
    const innerContainer = filterOverlay.querySelector('.fo__inner');

    if (!vacancy_overview_filters) return;

    function showFilters() {
      filterOverlay.classList.remove('fo--hidden')
    }

    function hideFilters() {
      filterOverlay.classList.add('fo--hidden')
    }

    filterOverlay.classList.contains('fo--hidden') ? showFilters() : hideFilters();

    clickoutside(innerContainer, () => {
      hideFilters();
    });
  }

  let standard_filters = (<section className="filter container--m gutter--m" aria-label="Filter resources">
    <ul className="filter__list">
      <li className="filter__item filter__item--search">
        <form
          role="search"
          id="resource-search"
          className="form--search"
          onSubmit={e => {
            e.preventDefault()
            args.searchSubmitted();
          }}
        >
          <input
            type="search"
            id="search-input"
            name="search"
            inputMode="search"
            className="search__input form__input"
            aria-label={t("search:your_search")}
            placeholder={t("search:your_search")}
            onChange={e => args.searchQueryChanged(e.target.value)}
            value={args.options.searchQuery}
          />
          <button type="submit" className="search__submit" title="Search">
            <span className="sr-text">{t("search:search")}</span>
            <svg width="18px" height="18px" aria-hidden="true">
              <use xlinkHref="#icon--search" />
            </svg>
          </button>
        </form>
      </li>
      {
        _resourceIndustryTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="resource-filter-industry" id="resource-filter-industry" disabled={false}
                value={selected_resourceIndustryTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(resourceIndustryTags, [event.target.value]))

                }}
              >
                <option value="">{t("search:all_industries")}</option>
                {_resourceIndustryTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null
      }
      {
        _resourceTypeTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="resource-filter-types" id="resource-filter-types" disabled={false}
                value={selected_resourceTypeTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(resourceTypeTags, [event.target.value]))
                }}
              >
                <option value="">{t("search:all_types")}</option>
                {_resourceTypeTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}
      {
        _newsTypeTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="news-filter-types" id="news-filter-types" disabled={false}
                value={selected_newsTypeTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(newsTypeTags, [event.target.value]))
                }}
              >
                <option value="">{t("search:all_types")}</option>
                {_newsTypeTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}
      {
        _vacancyContractTypeTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="opdract-filter-contract-types" id="opdracht-filter-contract-types" disabled={false}
                value={selected_vacancyContractTypeTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(vacancyContractTypeTags, [event.target.value]))
                }}
              >
                <option value="">All contract types</option>
                {_vacancyContractTypeTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}
      {
        _vacancyCountryTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="opdracht-filter-country-types" id="opdracht-filter-country-types" disabled={false}
                value={selected_vacancyCountryTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(vacancyCountryTags, [event.target.value]))
                }}
              >
                <option value="">All countries</option>
                {_vacancyCountryTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}

{
        _vacancyStateProvinceTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="opdracht-filter-stateprovince-types" id="opdracht-filter-stateprovince-types" disabled={false}
                value={selected_vacancyStateProvinceTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(vacancyStateProvinceTags, [event.target.value]))
                }}
              >
                <option value="">All state/provinces</option>
                {_vacancyStateProvinceTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}

      {
        _vacancyLocationTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="opdracht-filter-location-types" id="opdracht-filter-location-types" disabled={false}
                value={selected_vacancyLocationTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(vacancyLocationTags, [event.target.value]))
                }}
              >
                <option value="">All Locations</option>
                {_vacancyLocationTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}
      {
        _vacancyDepartmentTags.length > 0 ?
          <li className="filter__item">
            <div className="form__select">
              <select name="opdracht-filter-department-types" id="opdracht-filter-department-types" disabled={false}
                value={selected_vacancyDepartmentTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(vacancyDepartmentTags, [event.target.value]))
                }}
              >
                <option value="">All Departments</option>
                {_vacancyDepartmentTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </li>
          : null}
    </ul>
  </section>
  )



  let vacancy_overview_filters =
    (
      <>
        <div className="search-bar__pseudo-form">
          <div className="search-bar__form-inner">
            <div className="search-bar__group search-bar__group--primary">
              <label className="search-bar__form-label text--l">{t("search:your_search")}</label>
              <input
                type="search"
                id="search-input"
                name="search"
                inputMode="search"
                className="search-bar__input text--l"
                aria-label={t("search:your_search")}
                placeholder={``}
                onChange={e => args.searchQueryChanged(e.target.value)}
                value={args.options.searchQuery}
                onKeyPress={e => {
                  if (e.key === 'Enter' || e.keyCode === 13) {
                    document.getElementById("search-vacancies-btn").click();
                  }
                }}
              />
            </div>
            <div className="search-bar__group search-bar__group--actions">
              <button className='search-bar__button button button--filter'
                onClick={() => toggleFilters()}
              >
                <span>{t("search:filter")}</span>
                <svg aria-hidden="true" width={32} height={30}><use xlinkHref="#icon--filter" /></svg>
              </button>
              <button id='search-vacancies-btn' className='search-bar__button button button--primary' form='search-vacancies'>{t("search:search")}</button>
            </div>

            <div className="filter-overview fo fo--hidden">
              <div className="fo__inner grid--block">
                <button className="fo__button"
                  onClick={() => toggleFilters()}
                >
                  <span className="sr-text">Closing overlay button</span>
                  <svg className="fo__button--icon" aria-hidden="true" height="30" width="32">
                    <use xlinkHref="#icon--close-circled" />
                  </svg>
                </button>
                <h2 className="fo__title title--xs">{t("search:filter")}</h2>
                <form className="fo__form"
                  id='search-vacancies'
                  onSubmit={e => {
                    if (args.options.searchQuery != "" && args.options.searchQuery != undefined) {
                      datalayerHandler('search', "search", "filter_opdrachten", { label: args.options.searchQuery })
                    }
                    e.preventDefault()
                    args.searchSubmitted()
                    e.stopPropagation()
                  }}
                  onReset={e => {
                    args.filterTagChanged(args.options.tags.set(vacancyCountryTags, []).set(vacancyLocationTags, []).set(vacancyDepartmentTags, []).set(vacancyContractTypeTags, []), "")

                    e.preventDefault()
                    e.stopPropagation()
                  }}
                >
                  <ul className="fo__lists">
                    {renderVacancyOverviewCountryTagFilterCheckboxes(_vacancyCountryTags, vacancyCountryTags, args)}
                    {renderVacancyOverviewStateProvinceTagFilterCheckboxes(_vacancyStateProvinceTags, vacancyStateProvinceTags, args)}
                    {renderVacancyOverviewLocationTagFilterCheckboxes(_vacancyLocationTags, vacancyLocationTags, args)}
                    {renderVacancyOverviewDepartmentTagFilterCheckboxes(_vacancyDepartmentTags, vacancyDepartmentTags, args)}
                    {renderVacancyOverviewContractTagFilterCheckboxes(_vacancyContractTypeTags, vacancyContractTypeTags, args)}
                  </ul>

                  <div className="fo__bottom">
                    <div className="fo__icon"></div>
                    <div className="fo__actions">
                      <button
                        type="submit"
                        className="button button--primary"
                        onClick={() => toggleFilters()}>{t("search:show_vacancies")}
                      </button>
                      <button type="reset" className="link link--secondary">{t("search:reset_filters")}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    )


  let news_overview_filters = (<div className="block__filters hidden">
    <form
      onSubmit={e => {
        e.preventDefault()
        args.searchSubmitted();
      }}
      className="block__form">
      <div className="pageheader__form form__group--100">
        <input aria-label="Search" className="pageheader__input" type="search" placeholder="Blog, Event, Nieuws, etc."
          value={args.options.searchQuery}
          onChange={e => args.searchQueryChanged(e.target.value)}
        ></input>
        <svg aria-hidden="true" className="pageheader__inputicon" width="20px" height="20px"><use xlinkHref="#icon--search" /></svg>
      </div>

      <h3 className="filters__title title--m form__group--100">Story type</h3>
      {
        (_newsTypeTags || []).length > 0 ?
          <div className="form__group form__group--100">
            <div className="form__select">
              <select name="select1" id="select1"
                value={selected_newsTypeTags}
                onChange={event => {
                  datalayerHandler('actueel', "type", "filter_story", { label: event.target.value })
                  args.filterTagChanged(args.options.tags.set(newsTypeTags, [event.target.value]))
                }}
              >
                <option value="">{t("search:all_types")}</option>
                {_newsTypeTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </div>
          : null}
      <footer className="form__footer form__group form__group--100">
        <button type="submit" className="button button--primary"><span>Stories filteren</span></button>
      </footer>
    </form>
  </div>
  )

  let team_overview_filters = (<div className="block__filters hidden">
    <form className="block__form"
      onSubmit={e => {
        e.preventDefault()
        args.searchSubmitted();
      }}>
      <h3 className="filters__title title--m form__group--100">Discipline</h3>
      {
        (_teamMemberDisciplineTags || []).map(discipline => (
          <div className="form__group form__group--50 form__group--bool form__group--checkbox">
            <input id={`check1 ${discipline}`} key={`check1 ${discipline}`} type="checkbox" className="form__bool form__checkbox"
              checked={args.options.tags.get(teamMemberDisciplineTags)?.includes(discipline)}
              onClick={() => {
                let selected_disciplines = args.options.tags.get(teamMemberDisciplineTags)
                if (selected_disciplines.includes(discipline)) {
                  args.filterTagChanged(args.options.tags.set(teamMemberDisciplineTags, selected_disciplines.filter(d => d != discipline)))
                }
                else {
                  selected_disciplines.push(discipline)
                  args.filterTagChanged(args.options.tags.set(teamMemberDisciplineTags, selected_disciplines))
                }
              }} />
            <label htmlFor={`check1 ${discipline}`} className="form__label text--m">{discipline}</label>
          </div>
        ))
      }
      <footer className="form__footer form__group form__group--100">
        <button type="submit" className="button button--primary"><span>Team leden filteren</span></button>
      </footer>
    </form>
  </div>
  )


  let testimonials_overview_filters = (<div className="block__filters hidden">
    <form
      onSubmit={e => {
        e.preventDefault()
        args.searchSubmitted();
      }}
      className="block__form">
      {/* <div className="pageheader__form">
        <input aria-label="Search" className="pageheader__input" type="search" placeholder="Bijv. Engineer, Projectleider of Monteur"
          value={args.options.searchQuery}
          onChange={e => args.searchQueryChanged(e.target.value)}
        ></input>
        <svg aria-hidden="true" className="pageheader__inputicon" width="20px" height="20px"><use xlinkHref="#icon--search" /></svg>
      </div> */}

      <h3 className="filters__title title--m form__group--100">Testimonial type</h3>
      {
        (_testimonialsTags || []).length > 0 ?
          <div className="form__group form__group--100">
            <div className="form__select">
              <select name="select1" id="select1"
                value={selected_testimonialsTags}
                onChange={event => {
                  args.filterTagChanged(args.options.tags.set(testimonialTags, [event.target.value]))
                }}
              >
                <option value="">All testimonials</option>
                {_testimonialsTags.map(tag =>
                  <option value={tag}>{tag}</option>
                )}
              </select>
            </div>
          </div>
          : null}
      <footer className="form__footer form__group form__group--100">
        <button type="submit" className="button button--primary"><span>Testimonials filteren</span></button>
      </footer>
    </form>
  </div>
  )


  if (page_kind == "vacancy-overview") {
    return vacancy_overview_filters
  }
  if (page_kind == "news-overview") {
    return news_overview_filters
  }
  if (page_kind == "team-overview") {
    return team_overview_filters
  }
  if (page_kind == "testimonial-overview") {
    return testimonials_overview_filters
  }
  return standard_filters
}

export const renderEmpty = (): JSX.Element => <></>

let btnShowMoreLocation = false;
let btnShowMoreCountry = false;
let btnShowMoreDepartment = false;
let btnShowMoreStateProvince = false;
let btnShowMoreContract = false;

export const renderVacancyOverviewContractTagFilterCheckboxes = (tagValues: TagValues, tagType: string, args: FilterBlockArgs) => {
  let tagTitle = VacancyOverviewTagFilterTitle(tagType)
  let selected_tagItems = args.options.tags.get(tagType).sort()

  let nonselected = tagValues.filter(v => !selected_tagItems.includes(v))

  let newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, "", true)))}
        {newTagValues.length > 4 ?
          <>
            {skip(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreContract ? "" : "fo__item--hidden"}`, true)))}
          </>
          : null
        }
      </ul>
      {tagValues.length > 4 ?
        <button id={`btn_${tagTitle.toLowerCase()}`} className="fo__toggle link link--secondary" onClick={(e) => {
          document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`)
            .forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreContract) {
                  btnShowMoreContract = true
                }
              }
              else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreContract) {
                  btnShowMoreContract = false
                }
              }
            })
          !btnShowMoreContract ?
            document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_more")
            : document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_less")
        }}>
          {btnShowMoreDepartment ? t("search:show_less") : t("search:show_more")}
        </button>
        : null
      }
    </li>
  )
}
export const renderVacancyOverviewDepartmentTagFilterCheckboxes = (tagValues: TagValues, tagType: string, args: FilterBlockArgs) => {
  let tagTitle = VacancyOverviewTagFilterTitle(tagType)
  let selected_tagItems = args.options.tags.get(tagType).sort()

  let nonselected = tagValues.filter(v => !selected_tagItems.includes(v))

  let newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, "", true)))}
        {newTagValues.length > 4 ?
          <>
            {skip(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreDepartment ? "" : "fo__item--hidden"}`, true)))}
          </>
          : null
        }
      </ul>
      {tagValues.length > 4 ?
        <button id={`btn_${tagTitle.toLowerCase()}`} className="fo__toggle link link--secondary" onClick={(e) => {
          document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`)
            .forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreDepartment) {
                  btnShowMoreDepartment = true
                }
              }
              else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreDepartment) {
                  btnShowMoreDepartment = false
                }
              }
            })
          !btnShowMoreDepartment ?
            document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_more")
            : document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_less")
        }}>
          {btnShowMoreDepartment ? t("search:show_less") : t("search:show_more")}
        </button>
        : null
      }
    </li>
  )
}
export const renderVacancyOverviewStateProvinceTagFilterCheckboxes = (tagValues: TagValues, tagType: string, args: FilterBlockArgs) => {
  let tagTitle = VacancyOverviewTagFilterTitle(tagType)
  let selected_tagItems = args.options.tags.get(tagType).sort()

  let nonselected = tagValues.filter(v => !selected_tagItems.includes(v))

  let newTagValues = [...selected_tagItems, ...nonselected]
  return (
    newTagValues.length > 0 ?
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase().replace('/', '_')}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, "", false)))}
        {newTagValues.length > 4 ?
          <>
            {skip(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, ` fo__item--${tagTitle.toLowerCase().replace('/', '-')} ${btnShowMoreStateProvince ? "" : "fo__item--hidden"}`, false)))}
          </>
          : null
        }
      </ul>
      {tagValues.length > 4 ?
        <button id={`btn_${tagTitle.toLowerCase()}`} className="fo__toggle link link--secondary" onClick={(e) => {
          document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase().replace('/', '-')}`)
            .forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreStateProvince) {
                  btnShowMoreStateProvince = true
                }
              }
              else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreStateProvince) {
                  btnShowMoreStateProvince = false
                }
              }
            })
          !btnShowMoreStateProvince ?
            document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_more")
            : document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_less")
        }}>
          {btnShowMoreStateProvince ? t("search:show_less") : t("search:show_more")}
        </button>
        : null
      }
    </li>
    : null
  )
}
export const renderVacancyOverviewLocationTagFilterCheckboxes = (tagValues: TagValues, tagType: string, args: FilterBlockArgs) => {
  let tagTitle = VacancyOverviewTagFilterTitle(tagType)
  let selected_tagItems = args.options.tags.get(tagType).sort()

  let nonselected = tagValues.filter(v => !selected_tagItems.includes(v))

  let newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args)))}
        {newTagValues.length > 4 ?
          <>
            {skip(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreLocation ? "" : "fo__item--hidden"}`)))}
          </>
          : null
        }
      </ul>
      {tagValues.length > 4 ?
        <button id={`btn_${tagTitle.toLowerCase()}`} className="fo__toggle link link--secondary" onClick={(e) => {
          document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`)
            .forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreLocation) {
                  btnShowMoreLocation = true
                }
              }
              else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreLocation) {
                  btnShowMoreLocation = false
                }
              }
            })
          !btnShowMoreLocation ?
            document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_more")
            : document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_less")
        }}>
          {btnShowMoreLocation ? t("search:show_less") : t("search:show_more")}
        </button>
        : null
      }
    </li>
  )
}
export const renderVacancyOverviewCountryTagFilterCheckboxes = (tagValues: TagValues, tagType: string, args: FilterBlockArgs) => {
  let tagTitle = VacancyOverviewTagFilterTitle(tagType)
  let selected_tagItems = args.options.tags.get(tagType).sort()

  let nonselected = tagValues.filter(v => !selected_tagItems.includes(v))

  let newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, "", true)))}
        {newTagValues.length > 4 ?
          <>
            {skip(newTagValues, 4).map(tagValue => (renderSingleCheckboxes(tagValue, tagType, tagTitle, args, ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreCountry ? "" : "fo__item--hidden"}`, true)))}
          </>
          : null
        }
      </ul>
      {tagValues.length > 4 ?
        <button id={`btn_${tagTitle.toLowerCase()}`} className="fo__toggle link link--secondary" onClick={(e) => {
          document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`)
            .forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreCountry) {
                  btnShowMoreCountry = true
                }
              }
              else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreCountry) {
                  btnShowMoreCountry = false
                }
              }
            })
          !btnShowMoreCountry ?
            document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_more")
            : document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t("search:show_less")
        }}>
          {btnShowMoreCountry ? t("search:show_less") : t("search:show_more")}
        </button>
        : null
      }
    </li>
  )
}

export const renderSingleCheckboxes = (tagValue: string, tagType: string, tagTitle: string, args: FilterBlockArgs, extra_class_name?: string, translation: boolean = false) => {
  return (
    <li className={`fo__item${extra_class_name ? extra_class_name : ''}`} key={`tag_${tagType.toLowerCase()}_${tagValue.toLowerCase()}`}>
      <label htmlFor={`check1 ${tagValue}`} className="fo__label">
        <span className="fo__label-copy text--m">
          {translation ?
            tagType == vacancyContractTypeTags ?
              t(`search:tag_${tagValue.replace("&", "_").replace(",", "_").replace("-", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
              : tagType == vacancyCountryTags ?
                t(`search:tag_countryname:${tagValue.replace("&", "_").replace(",", "_").replace("-", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
                : t(`search:tag_${getDetailPageHeaderImage(tagValue).replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
            : tagValue}
        </span>
        <input id={`check1 ${tagValue}`} key={`check1 ${tagValue}`} type="checkbox" className="fo__checkbox"
          checked={args.options.tags.get(tagType)?.includes(tagValue)}
          onClick={() => {
            datalayerHandler('filter_opdrachten', tagTitle, "filter_opdrachten", { label: tagValue })
            let selected_tagItems = args.options.tags.get(tagType)
            if (selected_tagItems.includes(tagValue)) {
              args.filterTagChanged(args.options.tags.set(tagType, selected_tagItems.filter(t => t != tagValue)))
            }
            else {
              selected_tagItems.push(tagValue)
              args.filterTagChanged(args.options.tags.set(tagType, selected_tagItems))
            }
          }} />
      </label>
    </li>
  )
}
